/**
 * Humanize a session-end reason string for player-facing UI.
 *
 * Backend emits `SessionEnding.reason` via `format!("{r:?}")` (PascalCase
 * Debug) and `SessionEnded.reason` via serde rename_all = "snake_case".
 * Normalize both shapes before lookup so the same helper covers either
 * event. Unknown / missing reasons fall back to null — callers decide
 * whether to show a generic banner or nothing.
 */
const HUMAN: Record<string, string> = {
  modulecompleted: 'Adventure complete',
  tpk: 'The party has fallen',
  pckilled: 'Your heroes have fallen',
  partyvote: 'Party voted to end',
  partyretreat: 'Party retreated',
  dmended: 'Ended by GM',
  servershutdown: 'Server is shutting down',
  timeout: 'Session timed out',
  error: 'Session error',
  insufficienttokens: 'Out of tokens',
  leaderdisconnect: 'Party leader disconnected',
};

export function humanizeSessionEndReason(reason: string | null | undefined): string | null {
  if (!reason) return null;
  const key = reason.toLowerCase().replace(/[^a-z0-9]/g, '');
  return HUMAN[key] ?? null;
}

export function sessionEndingBannerText(reason: string | null | undefined): string {
  const human = humanizeSessionEndReason(reason);
  return human ? `Session ending. ${human}.` : 'Session ending…';
}
